var map = {
	"./curation-1-desktop.png": "e328",
	"./curation-1-mobile.png": "4f88",
	"./curation-2-mobile.png": "4779",
	"./donation-1-desktop.png": "e84c",
	"./donation-1-mobile.png": "f081",
	"./donation-2-desktop.png": "d8af",
	"./donation-2-mobile.png": "e755",
	"./gamification-1-desktop.png": "3058",
	"./gamification-1-mobile.png": "66df",
	"./icon-credit-card.svg": "3a40",
	"./icon-donation-calendar.svg": "b8ff",
	"./icon-graphic.svg": "292d",
	"./icon-membership.svg": "2ea6",
	"./icon-route.svg": "81e0",
	"./membership-1-desktop.png": "116d",
	"./membership-1-mobile.png": "7bc0",
	"./membership-2-desktop.png": "fed5",
	"./membership-2-mobile.png": "53cf",
	"./section-1.png": "d1254",
	"./ticketing-system-1-desktop.png": "6264",
	"./ticketing-system-1-mobile.png": "c643",
	"./ticketing-system-2-deskop.png": "db30",
	"./ticketing-system-2-mobile.png": "4e9b",
	"./tourguide-1-desktop.png": "270d",
	"./tourguide-1-mobile.png": "a167",
	"./webshop-1-desktop.png": "94fd",
	"./webshop-1-mobile.png": "4b08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a6f7";